import React from 'react'
import {connect} from 'react-redux'

import closeModal from './data/actions/close_modal'

import ModalView from './modal_view'
import GroupChatsLists from './group_chats_lists'
import GroupChatsListed from './group_chats_listed'
import GroupChatsSubscribed from './group_chats_subscribed'
import GroupChatsBookmarked from './group_chats_bookmarked'

class GroupChatsModal extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isActive: true
    }

    this.isThereCurrentUser = this.isThereCurrentUser.bind(this)
    this.onClose = this.onClose.bind(this)

    this.sections = [
      {
        name: 'all',
        label: 'All',
        Content: <GroupChatsListed/>
      },
      {
        name: 'bookmarks',
        label: 'My List',
        isActive: this.isThereCurrentUser,
        Content: <GroupChatsBookmarked/>
      },
      {
        name: 'subscriptions',
        label: 'Notifications',
        isActive: this.isThereCurrentUser,
        Content: <GroupChatsSubscribed/>
      }
    ]
  }

  onClose (e) {
    if (e) e.stopPropagation()

    this.setState({isActive: false})

    this.props.closeModal(this.props.modalKey)
  }

  isThereCurrentUser () {
    return this.props.currentUserUid ? true : false
  }

  renderInnerSections () {
    return (
      <GroupChatsLists sections={this.sections} activeSection={0}/>
    )
  }

  renderInfoLegend () {
    return (
      <div style={{background: '#EFEFEF', padding: 10, marginTop: 10, borderRadius: 4}}>
        <div style={{display: 'table'}}>
          <div style={{display: 'table-cell', width: 110, verticalAlign: 'middle'}}>
            <button className='btn btn-success btn-sm btn-stripped' style={{marginRight: 2, width: 101}}>Add to My List</button>:
          </div>
          <div style={{display: 'table-cell', verticalAlign: 'middle'}}>
            <span style={{display: 'inline-block', marginLeft: 5, fontSize: 12}}>
              Customize your list of chat rooms by adding or removing a room.
            </span>
          </div>
        </div>
        <div style={{display: 'table', marginTop: 5}}>
          <div style={{display: 'table-cell', width: 110, verticalAlign: 'middle'}}>
            <button className='btn btn-success btn-sm btn-stripped' style={{marginRight: 2, width: 101}}>Notifications</button>:
          </div>
          <div style={{display: 'table-cell', verticalAlign: 'middle'}}>
            <span style={{display: 'inline-block', marginLeft: 5, fontSize: 12}}>
              Get Instant, daily, or weekly email notifications for a specific chat room whenever other people are active in that room
            </span>
          </div>
        </div>
      </div>
    )
  }

  renderModalContent () {
    return (
      <div>
        <div className='modal-header' style={{paddingTop: 10, paddingBottom: 10}}>
          <h6 style={{fontSize: 18, margin: 0}}>Listing All Group Chats</h6>
        </div>
        <div className='modal-body'>
          {this.renderInnerSections()}
          {this.renderInfoLegend()}
        </div>
        <div className='modal-footer'>
          <div className='actions right'>
            <div className='cancel button default' onClick={this.onClose}>Close</div>
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (
      <ModalView isActive={this.state.isActive} onClose={this.onClose} size='large'>
        {this.renderModalContent()}
      </ModalView>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUserUid: state.getIn(['currentUser', 'uid'])
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: (modalKey) => dispatch(closeModal(modalKey))
  }
}

const GroupChatsModalContainer = connect(
  mapStateToProps, mapDispatchToProps
)(GroupChatsModal)

export default GroupChatsModalContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/group_chats_modal.js
 **/